import PanelForm from './../panel/Form'
import React from "react";

function Form() {

  return (
      <div className="wrapper">
          <PanelForm style={{background: '#FFFFFF', padding: 25}}>
              <h1>FAQ</h1>
          </PanelForm>
      </div>
  );
}

export default Form;
